import { LessonDto } from '../../../service/types'

/**
 * Get unique customer name(s) to display on the grid.
 * Multiple bookings may share the same customer (one per skier).
 */
export const getCustomerNames = (lesson: LessonDto): string => {
  const bookings = lesson.bookings ?? []
  if (bookings.length === 0) return '\u2014'
  const uniqueNames = [...new Set(bookings.map((b) => b.customer?.name).filter(Boolean))]
  return uniqueNames.length > 0 ? uniqueNames.join(', ') : '\u2014'
}

/**
 * Get total skier count to display.
 * Each booking IS one skier now.
 */
export const getSkierCount = (lesson: LessonDto): number => {
  return (lesson.bookings ?? []).length
}
